module.exports = __webpack_public_path__ + "static/media/add_clients_card_2.daab007a.svg";